<template>
  <div>
    <Toast position="top-right" />
    <b-modal
      id="faq-modal-center"
      centered
      no-close-button
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      size="lg"
    >
      <template #default="{ ok, cancel }">
        <div class="d-flex justify-content-between">
          <div>
            <h5 class="">Base de conhecimentos (FAQ)</h5>
            <p class="" style="font-size: 0.85rem; color: #949494">
              Preencha a base de conhecimentos de perguntas frequentes para
              treinar a IA
            </p>
          </div>
          <i
            style="cursor: pointer"
            @click="$bvModal.hide('faq-modal-center')"
            class="fa-solid fa-xmark text-dark"
          ></i>
        </div>

        <div class="mt-3">
          <h6 style="font-size: 0.95rem">Pergunta</h6>
          <b-form-input
            id="input-1"
            v-model="faq_payload.pergunta"
            :class="{
              'is-invalid':
                faq_payload.pergunta && faq_payload.pergunta.length < 15
            }"
          ></b-form-input>
          <b-form-invalid-feedback>
            A pergunta deve ter ao mínimo 15 caracteres.
          </b-form-invalid-feedback>
        </div>
        <div class="mt-3">
          <h6 style="font-size: 0.95rem">Resposta</h6>
          <b-form-textarea
            id="textarea"
            v-model="faq_payload.resposta"
            rows="12"
            no-resize
          ></b-form-textarea>
        </div>

        <div class="d-flex justify-content-between mt-4">
          <div class="d-flex align-items-center">
            <h6 style="font-size: 0.95rem" class="mt-3">Status da pergunta:</h6>
            <b-form-checkbox
              v-model="faq_payload.ativa"
              name="check-button"
              class="custom-switch custom-switch-color pt-0 ml-2"
              switch
              size="lg"
            ></b-form-checkbox>
          </div>
          <div>
            <button
              class="mr-2 p-2"
              @click="cancel()"
              style="
                border: 1px solid #472282;
                border-radius: 5px;
                color: #472282;
                cursor: pointer;
              "
            >
              Cancelar
            </button>
            <button
              class="mr-2 p-2"
              style="
                border: 1px solid #472282;
                border-radius: 5px;
                background-color: #472282;
                color: white;
              "
              :disabled="
                !faq_payload.pergunta ||
                faq_payload.pergunta.length < 15 ||
                !faq_payload.resposta
              "
              @click="handleSubmitFAQ"
              @keydown.enter.prevent="handleSubmitFAQ"
            >
              Salvar
            </button>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="chunk-modal-center"
      centered
      hide-header
      hide-footer
      size="lg"
      dialog-class="chunk-modal"
    >
      <template #default="{ cancel }">
        <div class="d-flex justify-content-between">
          <div>
            <h5>Conteúdo do documento</h5>
            <p style="font-size: 0.85rem; color: #949494">
              Edite o conteúdo do documento que será utilizado na base de
              conhecimento
            </p>
          </div>

          <i
            style="cursor: pointer"
            @click="$bvModal.hide('chunk-modal-center')"
            class="fa-solid fa-xmark text-dark"
          ></i>
        </div>

        <div class="mt-3">
          <h6 style="font-size: 0.95rem">Conteúdo</h6>
          <b-form-textarea
            v-model="chunk_payload.texto"
            rows="12"
            no-resize
            placeholder="Digite o conteúdo do documento..."
          />
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button
            class="mr-2 p-2"
            @click="cancel()"
            style="
              border: 1px solid #472282;
              border-radius: 5px;
              color: #472282;
              cursor: pointer;
            "
          >
            Cancelar
          </button>

          <button
            class="mr-2 p-2"
            style="
              border: 1px solid #472282;
              border-radius: 5px;
              background-color: #472282;
              color: white;
            "
            :disabled="!chunk_payload.texto"
            @click="salvarChunkModal"
          >
            Salvar
          </button>
        </div>
      </template>
    </b-modal>

    <div class="card p-6">
      <b-tabs content-class="mt-4">
        <!-- ================= TAB FAQ ================= -->
        <b-tab title="FAQ" active>
          <div class="">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div class="d-flex align-items-center">
                <h4 class="mr-2 mb-0">Base de conhecimentos (FAQ)</h4>
                <Tooltip
                  message="As perguntas frequentes são utilizadas para educar a Letícia, que ficará responsável por tirar todas as dúvidas dos seus clientes sobre a sua clínica"
                />
              </div>
              <div>
                <span class="p-input-icon-left mr-3">
                  <i class="pi pi-search" />
                  <InputText
                    type="text"
                    placeholder="Buscar pergunta"
                    v-model="busca_faq"
                    @input="buscarFAQ"
                  />
                </span>
                <button
                  @click="abrirModalFormFAQ(null)"
                  style="
                    background-color: #472282;
                    color: white;
                    border-radius: 4px;
                    padding: 7.5px 16px;
                  "
                >
                  Adicionar Pergunta
                </button>
                <b-button
                  variant="outline-secondary"
                  class="b-button-custom ml-2"
                  v-b-toggle.filtros
                >
                  <i class="fas fa-filter"></i> Filtros
                </b-button>
                <transition
                  enter-active-class="animate__animated animate__fadeIn animate__faster"
                >
                  <button
                    v-if="selectedFaqs.length"
                    style="
                      background-color: #eb0000;
                      color: white;
                      border-radius: 4px;
                      padding: 7.5px 16px;
                      transition: all 0.2s ease-in-out;
                    "
                    class="ml-2"
                    @click="deletarSelecionadosFAQ"
                  >
                    Excluir Selecionados
                  </button>
                </transition>
              </div>
            </div>

            <br />
            <b-collapse id="filtros" class="mb-4">
              <div class="d-flex">
                <div>
                  <h6>Status</h6>
                  <Dropdown
                    v-model="filtro_status"
                    :options="filtro_status_options"
                    optionLabel="name"
                    optionValue="value"
                    placeholder="Selecione o status"
                    style="width: 200px"
                    @change="buscarFAQ"
                  />
                </div>
              </div>
            </b-collapse>
            <div class="d-flex align-items-center ml-5" style="height: 35px">
              <div v-if="selectedFaqs.length">
                <Checkbox id="multiSelectedId" v-model="selectedAll" binary />
                <label for="multiSelectedId" class="mb-0 ml-2"
                  >Selecionar Todos</label
                >
              </div>
            </div>
            <ul class="list-group">
              <li
                class="faq-item-container"
                :class="{ active: faq.cof_ativa }"
                v-for="(faq, idx) in faqs_filtrados"
                :key="faq.conta_faq_id"
              >
                <div class="flexer w-100">
                  <div>
                    <Checkbox
                      v-model="selectedFaqs"
                      :value="faq.conta_faq_id"
                    />
                  </div>
                  <div class="faq-idx-container">
                    <p class="pergunta-numero d-flex justify-content-center">
                      {{ calculateFAQIdx(idx) }}
                    </p>
                  </div>
                  <div>
                    <b-form-checkbox
                      v-model="faq.cof_ativa"
                      name="check-button"
                      class="custom-switch custom-switch-color pt-0"
                      switch
                      size="lg"
                      @change="mudancaStatusFAQ(faq)"
                    >
                    </b-form-checkbox>
                  </div>
                  <div class="w-100">
                    <p class="pergunta">{{ faq.cof_pergunta }}</p>
                    <p class="resposta">{{ faq.cof_resposta }}</p>
                  </div>
                </div>
                <div class="acoes-container">
                  <div class="editar" @click="abrirModalFormFAQ(faq)">
                    <i class="fa-solid fa-pen" />
                  </div>
                  <div class="remover" @click="deletarFAQ(faq)">
                    <i class="fa-solid fa-trash"></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </b-tab>
        <!-- ================= TAB DOCUMENTOS ================= -->
        <b-tab title="Documentos">
          <div class="documentos-tab">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div class="d-flex align-items-center">
                <h4 class="mr-2 mb-0">Base de conhecimentos (Documentos)</h4>
                <Tooltip
                  message="A Letícia utiliza esses documentos (PDF, TXT e URL) como base de conhecimento para responder dúvidas dos seus clientes."
                />
              </div>
              <div class="d-flex align-items-center">
                <span class="p-input-icon-left mr-3">
                  <i class="pi pi-search" />
                  <InputText
                    type="text"
                    placeholder="Buscar documento"
                    v-model="busca_documento"
                    @input="buscarDocumentos"
                  />
                </span>
                <b-button
                  variant="primary"
                  @click="abrirModalDocumento"
                  style="
                    background-color: #472282;
                    color: white;
                    border-radius: 4px;
                    padding: 7.5px 16px;
                  "
                >
                  Adicionar documento
                </b-button>
              </div>
              <b-modal
                id="documento-modal-center"
                centered
                hide-footer
                title="Enviar documento"
              >
                <div class="mt-2">
                  <h6>Documento (URL ou Arquivo)</h6>

                  <b-form-input
                    :value="documento_url"
                    v-model="documento_url"
                    placeholder="Cole a URL (https://...)"
                    class="mb-3"
                    :disabled="hasFile"
                  />

                  <div class="text-center text-muted mb-2">ou</div>

                  <b-form-file
                    v-model="documento_file"
                    placeholder="Selecione um arquivo (PDF ou TXT)"
                    browse-text="Buscar"
                    accept=".pdf,.txt"
                    :disabled="hasUrl"
                  />
                </div>

                <div class="mt-3">
                  <h6>Descrição</h6>
                  <b-form-textarea
                    v-model="documento_descricao"
                    rows="4"
                    placeholder="Descreva o conteúdo do documento"
                  />
                </div>

                <div class="d-flex justify-content-end mt-4">
                  <b-button
                    variant="outline-secondary"
                    class="mr-2"
                    @click="$bvModal.hide('documento-modal-center')"
                  >
                    Cancelar
                  </b-button>

                  <b-button
                    variant="primary"
                    :disabled="!canSubmit"
                    @click="uploadDocumento"
                    style="
                      background-color: #472282;
                      color: white;
                      border-radius: 4px;
                      padding: 7.5px 16px;
                    "
                  >
                    Enviar documento
                  </b-button>
                </div>
              </b-modal>
            </div>
            <div class="mt-5 pt-4">
              <h6 class="mt-5">Documentos enviados</h6>
              <b-modal
                id="chunks-modal-center"
                size="lg"
                centered
                hide-footer
                title="Conteúdo do documento"
              >
                <div v-if="documentoSelecionado">
                  <h6 class="mb-3">{{ documentoSelecionado.nome }}</h6>

                  <div v-if="carregandoChunks" class="text-center my-4">
                    Carregando conteúdo...
                  </div>

                  <div v-else class="chunks-scroll-container">
                    <ul class="list-group">
                      <li
                        v-for="chunk in chunksModal"
                        :key="chunk.id"
                        class="faq-item-container chunk-item documentos-tab"
                      >
                        <div v-if="!chunk.editando" class="flexer w-100">
                          <div class="w-100">
                            <p class="pergunta" style="font-size: 0.85rem">
                              {{ chunk.texto }}
                            </p>
                          </div>
                        </div>

                        <div v-else>
                          <b-form-textarea
                            v-model="chunk.textoEditado"
                            rows="3"
                          />

                          <div class="mt-2">
                            <b-button
                              size="sm"
                              variant="success"
                              @click="salvarChunk(chunk)"
                            >
                              Salvar
                            </b-button>

                            <b-button
                              size="sm"
                              variant="outline-secondary"
                              class="ml-2"
                              @click="cancelarEdicaoChunk(chunk)"
                            >
                              Cancelar
                            </b-button>
                          </div>
                        </div>

                        <div class="acoes-container">
                          <div
                            class="editar"
                            @click="abrirModalFormChunk(chunk)"
                          >
                            <i class="fa-solid fa-pen"></i>
                          </div>

                          <div
                            class="remover"
                            @click="excluirChunk(documentoSelecionado, chunk)"
                          >
                            <i class="fa-solid fa-trash"></i>
                          </div>
                        </div>
                      </li>

                      <li v-if="!chunksModal.length" class="text-muted">
                        Nenhum conteúdo encontrado para este documento
                      </li>
                    </ul>
                  </div>
                </div>
              </b-modal>

              <b-collapse id="filtros-documentos" class="mb-4">
                <div class="d-flex">
                  <div>
                    <h6>Status</h6>
                    <Dropdown
                      v-model="filtro_status_documento"
                      :options="filtro_status_options"
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Selecione o status"
                      style="width: 200px"
                      @change="buscarDocumentos"
                    />
                  </div>
                </div>
              </b-collapse>
              <ul class="list-group">
                <li
                  v-for="(doc, idx) in documentos_filtrados"
                  :key="doc.id"
                  class="chunk-item faq-item-container"
                >
                  <div class="faq-idx-container">
                    <p class="pergunta-numero d-flex justify-content-center">
                      {{ calculateFAQIdx(idx) }}
                    </p>
                  </div>
                  <div class="flexer w-100">
                    <div class="w-100">
                      <p class="pergunta">{{ doc.nome }}</p>
                      <p class="resposta">{{ doc.descricao }}</p>
                    </div>
                  </div>
                  <div class="acoes-container">
                    <div
                      class="editar"
                      @click="abrirModalChunks(doc)"
                      title="Ver conteúdo"
                    >
                      <i class="fa-solid fa-eye"></i>
                    </div>

                    <div
                      class="remover"
                      @click="removerDocumento(doc)"
                      title="Excluir documento"
                    >
                      <i class="fa-solid fa-trash"></i>
                    </div>
                  </div>
                  <ul v-if="doc.showChunks" class="mt-3">
                    <li
                      v-for="chunk in doc.chunks"
                      :key="chunk.id"
                      style="font-size: 0.85rem"
                    >
                      <div
                        v-if="!chunk.editando"
                        class="d-flex justify-content-between"
                      >
                        <span>{{ chunk.texto }}</span>
                      </div>

                      <div v-else>
                        <b-form-textarea
                          v-model="chunk.textoEditado"
                          rows="3"
                        />

                        <div class="mt-2">
                          <b-button
                            size="sm"
                            variant="success"
                            @click="salvarChunk(chunk)"
                          >
                            Salvar
                          </b-button>

                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            class="ml-2"
                            @click="cancelarEdicaoChunk(chunk)"
                          >
                            Cancelar
                          </b-button>
                        </div>
                      </div>
                    </li>
                    <li v-if="!doc.chunks.length" class="text-muted">
                      Nenhum conteúdo encontrado para este documento
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service";
import API_LINKS from "../automacao/api.links";
import Swal from "sweetalert2";
import Dropdown from "primevue/dropdown";

export default {
  name: "FAQ",
  components: {
    Toast: () => import("primevue/toast"),
    Tooltip: () => import("@/view/pages/painel/dashboard/Tooltip.vue"),
    InputText: () => import("primevue/inputtext"),
    Checkbox: () => import("primevue/checkbox"),
    Dropdown
  },
  data() {
    return {
      faqs_conta: [],
      faqs_filtrados: [],
      busca_faq: "",
      filtro_status: null,
      filtro_status_options: [
        { name: "Todos", value: null },
        { name: "Ativo", value: true },
        { name: "Inativo", value: false }
      ],
      faq_payload: {
        pergunta: "",
        resposta: "",
        ativa: true
      },
      selectedAll: false,
      selectedFaqs: [],

      documento_file: null,
      documento_descricao: "",
      documentos: [],

      documentoSelecionado: null,
      chunksModal: [],
      carregandoChunks: false,

      chunk_payload: {
        id: null,
        texto: ""
      },

      documentos_conta: [],
      documentos_filtrados: [],
      busca_documento: "",
      filtro_status_documento: null,
      selectedDocumentos: [],
      documento_url: ""
    };
  },
  methods: {
    buscarFAQ() {
      this.faqs_filtrados = this.faqs_conta
        .filter((faq) => {
          const tem_na_pergunta = faq.cof_pergunta
            .toLowerCase()
            .includes(this.busca_faq.toLowerCase());

          const tem_na_resposta = faq.cof_resposta
            ?.toLowerCase()
            .includes(this.busca_faq.toLowerCase());

          return tem_na_pergunta || tem_na_resposta;
        })
        .filter((faq) => {
          if (this.filtro_status === null) {
            return true;
          }
          return faq.cof_ativa === this.filtro_status;
        });
      this.selectedFaqs = [];
    },
    async handleSubmitFAQ() {
      if (this.faq_payload.conta_faq_id) {
        return await this.editarFAQ();
      }
      const payload = {
        faq: {
          ...this.faq_payload
        }
      };

      await ApiService.post(API_LINKS.faq, payload);
      Swal.fire({
        title: "Pergunta cadastrada com sucesso!",
        icon: "success",
        showConfirmButton: false,
        timer: 500
      });
      this.getFAQs();
      this.$bvModal.hide("faq-modal-center");
    },
    async editarFAQ() {
      const payload = {
        faq: {
          ...this.faq_payload
        }
      };
      await ApiService.put(API_LINKS.faq, payload);
      this.getFAQs();
      Swal.fire({
        title: "Pergunta editada com sucesso!",
        icon: "success",
        showConfirmButton: false,
        timer: 500
      });
      this.$bvModal.hide("faq-modal-center");
    },
    async getFAQs() {
      const faqs = await ApiService.get(API_LINKS.faq);
      const active_faqs = faqs.data.faqs.filter((faq) => faq.cof_ativa);
      const inactive_faqs = faqs.data.faqs.filter((faq) => !faq.cof_ativa);
      active_faqs.sort((a, b) => {
        return a.conta_faq_id - b.conta_faq_id;
      });
      inactive_faqs.sort((a, b) => {
        return new Date(b.cof_data_cadastro) - new Date(a.cof_data_cadastro);
      });
      this.faqs_conta = [...active_faqs, ...inactive_faqs];
      this.buscarFAQ();
    },
    async deletarFAQ(faq) {
      // Swal.fire({
      //   title: "Deseja realmente deletar esta pergunta?",
      //   showCancelButton: true,
      //   confirmButtonText: "Sim",
      //   cancelButtonText: "Não",
      //   customClass: {
      //     cancelButton: "btn btn-secondary",
      //     confirmButton: "btn btn-danger"
      //   },
      //   buttonsStyling: false
      // })
      Swal.fire({
        title: "<strong>Deseja excluir esta pergunta?</strong>",
        html: "Esta pergunta será permanentemente excluída e não poderá ser recuperada, mas você poderá criá-la novamente a qualquer momento.",
        showCancelButton: true,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
        customClass: {
          container: "wellon-alerta",
          popup: "meu-alerta",
          title: "meu-titulo",
          htmlContainer: "meu-texto",
          cancelButton: "btn-cancelar",
          confirmButton: "btn-excluir"
        },
        buttonsStyling: false,
        reverseButtons: true
      }).then(async (result) => {
        if (result.value) {
          const payload = {
            conta_faq_id: [faq.conta_faq_id]
          };
          await ApiService.delete(API_LINKS.faq, payload);
          await this.getFAQs();
          Swal.fire({
            title: "Pergunta deletada com sucesso!",
            icon: "success",
            showConfirmButton: false,
            timer: 500
          });
        }
      });
    },
    async deletarSelecionadosFAQ() {
      Swal.fire({
        title: "<strong>Deseja excluir todas selecionadas?</strong>",
        html: "Essas perguntas serão excluídas permanentemente e não poderão ser recuperadas, mas você pode criá-las novamente quando quiser.",
        showCancelButton: true,
        confirmButtonText: "Excluir selecionadas",
        cancelButtonText: "Cancelar",
        customClass: {
          container: "wellon-alerta",
          popup: "meu-alerta",
          title: "meu-titulo",
          htmlContainer: "meu-texto",
          cancelButton: "btn-cancelar",
          confirmButton: "btn-excluir"
        },
        buttonsStyling: false,
        reverseButtons: true
      }).then(async (result) => {
        if (result.value) {
          const payload = {
            conta_faq_id: this.selectedFaqs
          };
          await ApiService.delete(API_LINKS.faq, payload);
          await this.getFAQs();
          Swal.fire({
            title: "Pergunta deletada com sucesso!",
            icon: "success",
            showConfirmButton: false,
            timer: 500
          });
        }
      });
    },
    calculateFAQIdx(idx) {
      return idx + 1 < 10 ? `0${idx + 1}` : idx + 1;
    },
    async abrirModalFormFAQ(faq) {
      if (!faq) {
        this.faq_payload = {
          pergunta: "",
          resposta: "",
          ativa: true
        };
      } else {
        this.faq_payload = {
          pergunta: faq.cof_pergunta,
          resposta: faq.cof_resposta,
          ativa: faq.cof_ativa,
          conta_faq_id: faq.conta_faq_id
        };
      }
      this.$bvModal.show("faq-modal-center");
    },
    async mudancaStatusFAQ(faq) {
      const payload = {
        ativa: faq.cof_ativa,
        conta_faq_id: faq.conta_faq_id,
        pergunta: faq.cof_pergunta,
        resposta: faq.cof_resposta
      };
      await ApiService.put(API_LINKS.faq, { faq: payload }).finally(() => {
        this.getFAQs();
      });
    },
    async buscarDocumentos() {
      this.documentos_filtrados = this.documentos_conta
        .filter((doc) => {
          const busca = this.busca_documento.toLowerCase();

          const tem_no_nome = doc.nome?.toLowerCase().includes(busca);

          const tem_na_descricao = doc.descricao?.toLowerCase().includes(busca);

          return tem_no_nome || tem_na_descricao;
        })
        .filter((doc) => {
          if (this.filtro_status_documento === null) {
            return true;
          }
          return doc.ativo === this.filtro_status_documento;
        });

      this.selectedDocumentos = [];
    },

    abrirModalFormChunk(chunk) {
      this.chunk_payload = {
        id: chunk.id,
        texto: chunk.texto
      };

      this.$bvModal.show("chunk-modal-center");
    },
    async salvarChunkModal() {
      try {
        await ApiService.post(API_LINKS.faq_documentos_editar_chunk, {
          chunk_id: this.chunk_payload.id,
          novo_texto: this.chunk_payload.texto
        });

        // atualiza o chunk aberto no modal
        const chunk = this.chunksModal.find(
          (c) => c.id === this.chunk_payload.id
        );

        if (chunk) {
          chunk.texto = this.chunk_payload.texto;
          chunk.textoEditado = this.chunk_payload.texto;
        }

        Swal.fire({
          title: "Conteúdo atualizado!",
          icon: "success",
          showConfirmButton: false,
          timer: 800
        });

        this.$bvModal.hide("chunk-modal-center");
      } catch (error) {
        Swal.fire({
          title: "Erro ao atualizar conteúdo",
          icon: "error"
        });
      }
    },

    async abrirModalDocumento() {
      this.documento_file = null;
      this.documento_descricao = "";

      this.$bvModal.show("documento-modal-center");
    },
    async uploadDocumento() {
      try {
        if (this.documento_url && this.isValidUrl(this.documento_url)) {
          await ApiService.post(API_LINKS.faq_documentos_upload_url, {
            url: this.documento_url,
            descricao: this.documento_descricao
          });
          this.documento_descricao = "";
          this.documento_url = "";

          this.$bvModal.hide("documento-modal-center");
          this.getDocumentos();

          Swal.fire({
            title: "URL adicionada com sucesso!",
            icon: "success",
            showConfirmButton: false,
            timer: 800
          });
        } else if (this.documento_file) {
          const formData = new FormData();

          formData.append("arquivo", this.documento_file);
          formData.append("descricao", this.documento_descricao);

          await ApiService.post(API_LINKS.faq_documentos_upload, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          });

          this.documento_file = null;
          this.documento_descricao = "";

          this.$bvModal.hide("documento-modal-center");
          this.getDocumentos();
          Swal.fire({
            title: "Documento enviado com sucesso!",
            icon: "success",
            showConfirmButton: false,
            timer: 800
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Erro ao enviar documento",
          icon: "error",
          showConfirmButton: false,
          timer: 1000
        });
      }
    },
    async getDocumentos() {
      const response = await ApiService.get(API_LINKS.faq_documentos_listar);

      this.documentos_conta = response.data.arquivos.map((arquivo) => ({
        id: arquivo.id,
        nome: arquivo.nome,
        descricao: arquivo.descricao,
        url: arquivo.url,
        extensao: arquivo.extensao,
        showChunks: false,
        chunks: []
      }));
      this.buscarDocumentos();
    },
    async abrirModalChunks(doc) {
      try {
        this.documentoSelecionado = doc;
        this.carregandoChunks = true;
        this.chunksModal = [];

        const response = await ApiService.get(API_LINKS.faq_documentos_chunks);

        const chunksPorDocumento = response.data.chunks || {};

        this.chunksModal = chunksPorDocumento[doc.id]
          ? chunksPorDocumento[doc.id].map((c) => ({
              id: c.conta_embedded_documento_id,
              texto: c.chunk_texto,
              ordem: c.chunk_seq,
              editando: false,
              textoEditado: c.chunk_texto
            }))
          : [];

        this.$bvModal.show("chunks-modal-center");
      } catch (error) {
        Swal.fire("Erro", "Erro ao carregar conteúdo do documento", "error");
      } finally {
        this.carregandoChunks = false;
      }
    },

    async removerDocumento(doc) {
      try {
        const confirm = await Swal.fire({
          title: "Excluir documento?",
          text: "Esse arquivo será removido permanentemente.",
          icon: "warning",
          showCancelButton: true,

          confirmButtonText: "Excluir",
          cancelButtonText: "Cancelar",

          confirmButtonColor: "#472282",

          buttonsStyling: true
        });

        if (!confirm.isConfirmed) return;

        await ApiService.delete(API_LINKS.faq_documentos_deletar, {
          documento_id: doc.id
        });
        Swal.fire({
          title: "Documento removido!",
          icon: "success",
          showConfirmButton: false,
          timer: 800
        });

        this.documentos = this.documentos.filter((d) => d.id !== doc.id);
        this.getDocumentos();
        this.buscarDocumentos();
      } catch (error) {
        console.error(error.response?.data || error);

        Swal.fire({
          title: "Erro ao remover documento",
          text:
            error?.response?.data?.erro ||
            error?.response?.data?.message ||
            "Erro ao remover documento",
          icon: "error"
        });
      }
    },
    async salvarChunk(chunk) {
      try {
        await ApiService.post(API_LINKS.faq_documentos_editar_chunk, {
          chunk_id: chunk.id,
          novo_texto: chunk.textoEditado
        });

        // atualiza localmente
        chunk.texto = chunk.textoEditado;
        chunk.editando = false;

        Swal.fire({
          title: "Conteúdo atualizado!",
          icon: "success",
          showConfirmButton: false,
          timer: 800
        });
      } catch (error) {
        Swal.fire({
          title: "Erro ao atualizar conteúdo",
          icon: "error"
        });
      }
    },

    cancelarEdicaoChunk(chunk) {
      chunk.textoEditado = chunk.texto;
      chunk.editando = false;
    },

    async excluirChunk(doc, chunk) {
      try {
        const confirm = await Swal.fire({
          title: "Excluir conteúdo?",
          text: "Esse trecho será removido permanentemente.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Excluir",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#472282"
        });

        if (!confirm.isConfirmed) return;

        await ApiService.delete(API_LINKS.faq_documentos_chunk_deletar, {
          chunk_id: chunk.id
        });

        Swal.fire({
          title: "Conteúdo removido!",
          icon: "success",
          showConfirmButton: false,
          timer: 800
        });

        this.chunksModal = this.chunksModal.filter((c) => c.id !== chunk.id);

        if (doc?.chunks) {
          doc.chunks = doc.chunks.filter((c) => c.id !== chunk.id);
        }
      } catch (error) {
        Swal.fire({
          title: "Erro ao remover conteúdo",
          icon: "error",
          showConfirmButton: false,
          timer: 1200
        });
      }
    },
    isValidUrl(value) {
      try {
        new URL(value);
        return true;
      } catch (e) {
        return false;
      }
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Chatbot"
      },
      {
        title: "FAQ",
        route: "/painel/chatbot/faq"
      }
    ]);
    const init = async () => {
      this.getFAQs();
      this.getDocumentos();
    };
    init();
  },
  computed: {
    multiSelected() {
      return this.faqs_filtrados?.some((faq) => faq?._selected);
    },
    // todosSelecionados: {
    //   get() {
    //     return this.faqs_filtrados?.every((faq) => faq?._selected);
    //   },
    //   set(value) {
    //     this.selectedAll = value;
    //     this.faqs_filtrados.forEach((faq) => (faq._selected = value));
    //   }
    // }
    todosSelecionados() {
      return this.faqs_filtrados?.every((faq) => faq?._selected);
    },
    hasFile() {
      return (
        this.documento_file instanceof File ||
        (Array.isArray(this.documento_file) && this.documento_file.length > 0)
      );
    },

    hasUrl() {
      return (
        typeof this.documento_url === "string" &&
        this.documento_url.trim().length > 0
      );
    },

    hasValidUrl() {
      return this.hasUrl && this.isValidUrl(this.documento_url);
    },

    canSubmit() {
      if (!this.documento_descricao || this.documento_descricao.trim() === "") {
        return false;
      }

      if (this.hasUrl) {
        return this.hasValidUrl;
      }

      return this.hasFile;
    }
  },
  watch: {
    // todosSelecionados(newValue) {
    //   this.selectedAll = newValue;
    // },
    selectedAll(newValue) {
      const todos = this.faqs_filtrados.map((i) => i.conta_faq_id);
      this.selectedFaqs = newValue ? todos : [];
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300&display=swap");

.p-togglebutton.p-button {
  background: #e4e6ef;
  border: 1px solid #ced4da;
  color: #495057 !important;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
  text-transform: uppercase;
}

.p-togglebutton.p-button:not(.p-disabled):not(.p-highlight):hover {
  background: #f8f9fa;
  border: 1px solid #ced4da;
  color: #495057 !important;
}

.p-togglebutton.p-button.p-highlight {
  background: #e8f3d6;
  border-color: #e8f3d6;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s;
}

.faq-item-container {
  display: flex;
  height: 75px;
  background: #eeeeee;
  opacity: 0.5;
  border: 1px solid #adb5bd;
  &.active {
    background: white;
    border-color: #dcdfe3;
    opacity: 1;
  }
  border-radius: 4px !important;
  align-items: center;
  justify-content: space-betweens;
  width: 100%;
  padding: 1rem;
  margin-bottom: 1rem;
  p {
    margin: 0;
  }
  .flexer {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .acoes-container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    div {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .editar {
      border: 1px solid #dcdfe3;
      border-radius: 4px;
      i {
        font-size: 1rem;
        color: #404254 !important;
      }
    }
    .remover {
      border: 1px solid #dcdfe3;
      border-radius: 4px;
      i {
        font-size: 1rem;
        color: #404254 !important;
      }
    }
  }
  .faq-idx-container {
    font-size: 1.8rem;
    width: 60px;
    .pergunta-numero {
      color: #472282;
      margin: 0;
      width: 100%;
    }
  }
  .pergunta {
    font-size: 1rem;
    font-weight: 600;
    color: #000;
    margin: 0;
  }
  .resposta {
    font-size: 0.9rem;
    width: 95%;
    color: #000;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: keep-all;
  }
}

.novo-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px dashed #000;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  height: 59px;
  &:hover {
    background: #eee;
    color: #000;
  }
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #472282;
  background-color: #472282;
}

.wellon-alerta .meu-alerta {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  text-align: left;
}

.wellon-alerta .meu-titulo {
  font-weight: 600;
  font-size: 1.25rem;
  color: #333;
}

.wellon-alerta .meu-texto {
  color: #6c757d;
  font-size: 0.95rem;
  margin-top: 0.5rem;
  padding: 0;
}

.wellon-alerta .btn-cancelar {
  background-color: #fff;
  border: 1px solid #6f42c1;
  color: #6f42c1;
  border-radius: 6px;
  padding: 0.5rem 1.25rem;
  font-weight: 500;
  margin-right: 0.5rem;
}

.wellon-alerta .btn-excluir {
  background-color: #6f42c1;
  border: 1px solid #6f42c1;
  color: white;
  border-radius: 6px;
  padding: 0.5rem 1.25rem;
  font-weight: 500;
}

.wellon-alerta .swal2-header {
  display: block;
  text-align: left !important;
}

.wellon-alerta .swal2-content {
  display: block;
  text-align: left !important;
}

.wellon-alerta .swal2-actions {
  display: flex;
  justify-content: flex-end;
  padding-right: 1rem;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.documento-item {
  background: #fff;
  color: #000;
}

.documentos-tab .faq-item-container:not(.chunk-item) {
  background-color: #fff;
  opacity: 1;
}

.chunks-modal .pergunta {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.4;
}

.chunk-item .pergunta {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.4;
}

.chunk-item {
  height: auto;
  align-items: flex-start;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
}

.list-group .chunk-item {
  background-color: #ffffff !important;
  opacity: 1 !important;
}

// .v-enter-from,
// .v-leave-to {
//   opacity: 0;
// }
</style>
